var pageChanging = false;
var currPage = 0;

var pageTitles = [
	"Installing Y Nouveau with Citra",
	"Installing Y Nouveau with Luma3DS",
	"Installing Y Nouveau with Android",
	"Setting Up Citra",
];

$(window).on("load", function () {
	$(".downloadBtn a").on("click", SendDownloadIncrement);

	currPage = parseInt(localStorage.getItem("DownloadPage") ?? "0");
	$(`#pageTitle`).text(pageTitles[currPage]);
	$(`[data-page=${currPage}]`).css({
		display: "flex"
	});

	$(".pageLeft").on("click", () => ChangePage(false));
	$(".pageRight").on("click", () => ChangePage(true));

	$(window).on("keyup", function (e) {
		if (pageChanging) return;

		if (e.key == "ArrowLeft")
			ChangePage(false);
		else if (e.key == "ArrowRight")
			ChangePage(true);
	});

	$(".jump").on("click", function () {
		if (pageChanging) return;
		pageChanging = true;

		let jumpPage = $(this).data("jump-page");
		let jumpTag = $(this).data("jump-tag");

		$(`#title`).css("opacity", 0);
		$(`[data-page=${currPage}]`).fadeOut(250, () => JumpToTag(jumpPage, jumpTag));
	});
});

async function SendDownloadIncrement(e: JQuery.ClickEvent) {
	let downloadSrcMatch = $(e.currentTarget).attr("href")?.match(/\/([\w.]+).zip/);

	if (!downloadSrcMatch)
		return;

	let downloadObj = { downloadSource: downloadSrcMatch[1] };
	const response = await fetch('/rest/increment-download', {
		method: "POST",
		headers: {
			"Content-Type": "application/json"
		},
		body: JSON.stringify(downloadObj)
	});

	if (!response.ok)
		console.log(`Response Status: ${response.status}`);
}

function ChangePage(pageRight: boolean) {
	if (pageChanging) return;

	pageChanging = true;
	$(`#pageTitle`).css("opacity", 0);

	$(`[data-page=${currPage}]`).fadeOut(250, () => GetNewPage(currPage, pageRight));
}

function GetNewPage(pageNum: number, pageRight: boolean) {
	if (pageRight)	pageNum++;
	else						pageNum--;

	if (pageNum < 0 ) pageNum += pageTitles.length;
	pageNum = pageNum % pageTitles.length;

	$(`#pageTitle`).text(pageTitles[pageNum]);
	$(`#pageTitle`).css("opacity", 100);

	$(`[data-page=${pageNum}]`).fadeIn(250).css("display", "flex");

	currPage = pageNum;
	localStorage.setItem("DownloadPage", String(currPage));
	pageChanging = false;
}

function JumpToTag(jumpPage: number, jumpTag: string) {
	$(`#pageTitle`).text(pageTitles[jumpPage]);
	$(`#pageTitle`).css("opacity", 100);

	$(`[data-page=${jumpPage}]`).fadeIn(250).css("display", "flex");

	if (jumpTag != "no-tag") {
		let jqTag: JQuery = $(`[data-tag=${jumpTag}]`);
		if (jqTag.length == 0)
			throw new Error(`Unable to find Jump Tag: ${jumpTag}`);

		$("html, body").animate({
			scrollTop: jqTag.offset()!.top
		}, 250);
	}
	else {
		$("html, body").animate({
			scrollTop: $("#pageTitle").offset()!.top
		}, 250);
	}

	currPage = jumpPage;
	localStorage.setItem("DownloadPage", String(currPage));
	pageChanging = false;
}